import { render } from "./TheDoughnutChart.vue?vue&type=template&id=f9e10c30"
import script from "./TheDoughnutChart.vue?vue&type=script&lang=js"
export * from "./TheDoughnutChart.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Softwaresul\\Projetos Node\\LWP\\Nil Key\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__